export default __webpack_public_path__ + "static/media/paint-04 (1).6e94751b.jpg";